export default [{
    title: 'Reportes',
    icon: 'PieChartIcon',
    children: [
        {
            title: 'Fondo de Garantía',
            route: 'reports-guarantee-fund',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte CTS',
            route: 'reports-cts',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte CTS Cartas No Adeudos',
            route: 'reports-cts-cartas',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte Gratificación',
            route: 'reports-gratification',
            action: 'read',
		    resource: 'reports'
        },
        {
            title: 'Reporte Gratificación Cartas No Adeudos',
            route: 'reports-gratification-cartas',
            action: 'read',
		    resource: 'reports'
        }
    ]
},
{
    title: 'Herramientas',
    icon: 'ToolIcon',
    children: [
        {
            title: 'Generar Formularios Prueba',
            route: 'tools-generate-test-forms',
            action: 'manage',
		    resource: 'tools'
        }
    ]
}];